// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Uuid = require("uuid");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var CustomMap$SmartcutsMacros = require("./CustomMap.bs.js");
var DeccoUtils$SmartcutsMacros = require("../../bs-utils/src/DeccoUtils.bs.js");

var Constants = {
  defaultWaitMs: 250
};

var uuid_encode = Decco.stringToJson;

var uuid_decode = Decco.stringFromJson;

function entry_encode(encoder_event, encoder_firstCallData, v) {
  return Js_dict.fromArray([
              [
                "lastEventTime",
                Decco.floatToJson(v.lastEventTime)
              ],
              [
                "waitMs",
                Decco.floatToJson(v.waitMs)
              ],
              [
                "timeoutId",
                Decco.optionToJson(DeccoUtils$SmartcutsMacros.timeoutId_encode, v.timeoutId)
              ],
              [
                "event",
                Curry._1(encoder_event, v.event)
              ],
              [
                "firstCallData",
                Curry._1(encoder_firstCallData, v.firstCallData)
              ]
            ]);
}

function entry_decode(decoder_event, decoder_firstCallData, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var lastEventTime = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "lastEventTime"), null));
  if (lastEventTime.TAG === /* Ok */0) {
    var waitMs = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "waitMs"), null));
    if (waitMs.TAG === /* Ok */0) {
      var timeoutId = Decco.optionFromJson(DeccoUtils$SmartcutsMacros.timeoutId_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "timeoutId"), null));
      if (timeoutId.TAG === /* Ok */0) {
        var $$event = Curry._1(decoder_event, Belt_Option.getWithDefault(Js_dict.get(dict$1, "event"), null));
        if ($$event.TAG === /* Ok */0) {
          var firstCallData = Curry._1(decoder_firstCallData, Belt_Option.getWithDefault(Js_dict.get(dict$1, "firstCallData"), null));
          if (firstCallData.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      lastEventTime: lastEventTime._0,
                      waitMs: waitMs._0,
                      timeoutId: timeoutId._0,
                      event: $$event._0,
                      firstCallData: firstCallData._0
                    }
                  };
          }
          var e = firstCallData._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".firstCallData" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = $$event._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".event" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = timeoutId._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".timeoutId" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = waitMs._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".waitMs" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = lastEventTime._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".lastEventTime" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function t_encode(encoder_event, encoder_firstCallData, v) {
  return CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_encode((function (param) {
                return entry_encode(encoder_event, encoder_firstCallData, param);
              }), v);
}

function t_decode(decoder_event, decoder_firstCallData, v) {
  return CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_decode((function (param) {
                return entry_decode(decoder_event, decoder_firstCallData, param);
              }), v);
}

function mapEntry(mapEvent, mapFirstCallData, entry) {
  return {
          lastEventTime: entry.lastEventTime,
          waitMs: entry.waitMs,
          timeoutId: entry.timeoutId,
          event: Curry._1(mapEvent, entry.event),
          firstCallData: Curry._1(mapFirstCallData, entry.firstCallData)
        };
}

function map(mapEvent, mapFirstCallData, manager) {
  return Belt_MapString.map(manager, (function (param) {
                return mapEntry(mapEvent, mapFirstCallData, param);
              }));
}

function updateTimeoutId(id, timeoutId, debouncedEntries) {
  return Belt_MapString.update(debouncedEntries, id, (function (maybeEntry) {
                if (maybeEntry !== undefined) {
                  return {
                          lastEventTime: maybeEntry.lastEventTime,
                          waitMs: maybeEntry.waitMs,
                          timeoutId: Caml_option.some(timeoutId),
                          event: maybeEntry.event,
                          firstCallData: maybeEntry.firstCallData
                        };
                }
                
              }));
}

function clearTimeoutId(id, debouncedEntries) {
  return Belt_MapString.update(debouncedEntries, id, (function (maybeEntry) {
                if (maybeEntry !== undefined) {
                  return {
                          lastEventTime: maybeEntry.lastEventTime,
                          waitMs: maybeEntry.waitMs,
                          timeoutId: undefined,
                          event: maybeEntry.event,
                          firstCallData: maybeEntry.firstCallData
                        };
                }
                
              }));
}

function removeEntry(id, debouncedEntries) {
  return Belt_MapString.remove(debouncedEntries, id);
}

function maybeDebounceEvent($$event, timestamp, firstCallData, isDebouncable, doesEventMatchEntry, waitMsOpt, debouncedEntries) {
  var waitMs = waitMsOpt !== undefined ? waitMsOpt : 250;
  if (!Curry._1(isDebouncable, $$event)) {
    return /* NoDebounce */0;
  }
  var match = Belt_MapString.findFirstBy(debouncedEntries, (function (_id, entry) {
          return Curry._2(doesEventMatchEntry, $$event, entry);
        }));
  if (match !== undefined) {
    var matchingEntry = match[1];
    var id = match[0];
    if (timestamp - matchingEntry.lastEventTime >= matchingEntry.waitMs) {
      return {
              TAG: /* ShouldInvoke */2,
              _0: matchingEntry,
              _1: Belt_MapString.remove(debouncedEntries, id)
            };
    }
    var updatedEntry_waitMs = matchingEntry.waitMs;
    var updatedEntry_timeoutId = matchingEntry.timeoutId;
    var updatedEntry_firstCallData = matchingEntry.firstCallData;
    var updatedEntry = {
      lastEventTime: timestamp,
      waitMs: updatedEntry_waitMs,
      timeoutId: updatedEntry_timeoutId,
      event: $$event,
      firstCallData: updatedEntry_firstCallData
    };
    return {
            TAG: /* DidUpdateDebounceEvent */1,
            _0: id,
            _1: updatedEntry,
            _2: Belt_MapString.set(debouncedEntries, id, updatedEntry)
          };
  }
  var id$1 = Uuid.v1();
  var debouncedEvent = {
    lastEventTime: timestamp,
    waitMs: waitMs,
    timeoutId: undefined,
    event: $$event,
    firstCallData: firstCallData
  };
  return {
          TAG: /* DidAddNewDebounceEvent */0,
          _0: id$1,
          _1: debouncedEvent,
          _2: Belt_MapString.set(debouncedEntries, id$1, debouncedEvent)
        };
}

function handleTimerExpired(id, debouncedEntries) {
  var matchingEntry = Belt_MapString.get(debouncedEntries, id);
  if (matchingEntry !== undefined) {
    if (Date.now() - matchingEntry.lastEventTime >= matchingEntry.waitMs) {
      return [
              Belt_MapString.remove(debouncedEntries, id),
              {
                TAG: /* DispatchDidFlushDebouncedEvent */1,
                _0: matchingEntry
              }
            ];
    } else {
      return [
              clearTimeoutId(id, debouncedEntries),
              {
                TAG: /* ResetDebounceTimeout */0,
                _0: id,
                _1: undefined
              }
            ];
    }
  }
  
}

var empty;

var size = Belt_MapString.size;

exports.Constants = Constants;
exports.uuid_encode = uuid_encode;
exports.uuid_decode = uuid_decode;
exports.entry_encode = entry_encode;
exports.entry_decode = entry_decode;
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.mapEntry = mapEntry;
exports.map = map;
exports.empty = empty;
exports.size = size;
exports.updateTimeoutId = updateTimeoutId;
exports.clearTimeoutId = clearTimeoutId;
exports.removeEntry = removeEntry;
exports.maybeDebounceEvent = maybeDebounceEvent;
exports.handleTimerExpired = handleTimerExpired;
/* uuid Not a pure module */
